import useSWR from 'swr'

import { fetchTvl } from '../utils/tokens'

export default function useTvl() {
  return useSWR('TVL', fetchTvl, {
    revalidateOnFocus: false,
  })
}
